import React from 'react';
import Cards from 'react-credit-cards-2';
import 'react-credit-cards-2/dist/es/styles-compiled.css';
import { CardNumber } from './components/CardNumber';
import { CardMonthYear } from './components/CardMonthYear';
import { CardCvc } from './components/CardCvc';
import { usePaymentStore } from '../../../../state/paymentStore';
import { isMobileScreen } from '@apply/ui';

export interface CardInfo {
    expiry: string;
    cvc: string;
    number: string;
    cardType: undefined | 'VISA' | 'MASTERCARD';
}

export interface CardPaymentProps {
    disabled: boolean;
}

export const CardPayment: React.FC<CardPaymentProps> = ({ disabled }) => {
    const mobileScreen = isMobileScreen();
    const name = usePaymentStore((s) => s.name);
    const cardMonthYear = usePaymentStore((s) => s.cardMonthYear);
    const cvc = usePaymentStore((s) => s.cvc);
    const cardNumber = usePaymentStore((s) => s.cardNumber);
    const cardFocus = usePaymentStore((s) => s.cardFocus);

    const getColumnSize = (numberOfColumns: number, resizeForMobile: boolean) => {
        switch (numberOfColumns) {
            case 3:
                return resizeForMobile && mobileScreen ? '100%' : '32%';
            case 2:
                return resizeForMobile && mobileScreen ? '100%' : '49%';
            case 1:
                return '100%';
            default:
                return '100%';
        }
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
            <div style={{ width: getColumnSize(2, true), display: 'flex', flexWrap: 'wrap', alignContent: 'center' }}>
                <Cards
                    name={name ?? ''}
                    cvc={cvc ?? ''}
                    expiry={cardMonthYear ?? ''}
                    number={cardNumber ?? ''}
                    focused={cardFocus}
                />
            </div>
            <div style={{ width: getColumnSize(2, true) }}>
                <CardNumber disabled={disabled} />
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                    <div style={{ width: getColumnSize(2, false), display: 'flex', flexWrap: 'wrap', alignContent: 'center' }}>
                        <CardMonthYear disabled={disabled} />
                    </div>
                    <div style={{ width: getColumnSize(2, false), display: 'flex', flexWrap: 'wrap', alignContent: 'center' }}>
                        <CardCvc disabled={disabled} />
                    </div>
                </div>
            </div>
        </div>
    );
};
